
import { Component, Prop, Vue } from "vue-property-decorator";

import UploaderState from "@/components/NewFileUploader/NbNewUploader/UploaderState.vue";
import UploaderImage from "@/assets/images/uploader.svg";

const MESSAGES = {
  uploadNotStart: "Drag and drop or choose \n from your device",
  uploadStart: "Release to upload",
  keyboardHint: "Use <b>ctrl + v</b> to paste",
  addMore: "Add more",
};

const ADD_MORE_IMAGE_PROPS = {
  width: 32,
  height: 32,
};

const ADD_MORE_IMAGE_BIG_PROPS = {
  width: 64,
  height: 64,
};

const STATE_PROPS = {
  border: true,
};

const CLASS = "nb-new-uploader-drag-and-drop";

@Component({
  components: { UploaderState },
})
export default class UploaderDragAndDrop extends Vue {
  @Prop({ type: Boolean, default: false }) readonly hasUploadedFiles?: boolean;
  @Prop({ type: Boolean, default: false }) readonly stretch?: boolean;
  @Prop({ type: Boolean, default: true }) readonly multiple?: boolean;
  @Prop({ type: String, default: "" }) readonly state?: string;

  MESSAGES = MESSAGES;

  UPLOADER_IMAGE = UploaderImage;

  ADD_MORE_IMAGE_PROPS = ADD_MORE_IMAGE_PROPS;
  ADD_MORE_IMAGE_BIG_PROPS = ADD_MORE_IMAGE_BIG_PROPS;

  STATE_PROPS = STATE_PROPS;

  get classes() {
    const { stretch, multiple } = this;

    return {
      [`${CLASS}_stretch`]: stretch,
      [`${CLASS}_multiple`]: multiple,
    };
  }

  get horizontal() {
    return !!this.hasUploadedFiles;
  }

  startUploadFromInput() {
    const target = this.$refs.fileInput as HTMLElement;

    if (!target) return;

    target.click();
  }

  uploadFilesFromInput(event) {
    const { files } = event?.target;

    if (!files) return;

    this.$emit("upload", files);
  }
}
